export const projectCardStyles = {
  color: "#004A55",
  backgroundColor: "#F5F5F5",
  margin: "1rem 0",
  width: "100%",
};

export const darkProjectCardStyles = {
  color: "white",
  backgroundColor: "#4e4e50",
  margin: "1rem 0",
  width: "100%",
};

export const projectCardContentStyling = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "stretch",
  paddingBottom: "0.5rem",
};

export const projectCardContentButtonsStyling = {
  marginTop: "2rem",
  paddingBottom: "0.5rem",
};

export const projectCardIconStyling = {
  margin: "0 1rem",
  height: "1.5rem",
};
export const websiteButtonStyle = {
  backgroundColor: "#0B66C2",
  margin: "1rem 1rem",
  "&:hover": {
    backgroundColor: "#0B66C2",
  },
  "&:active": {
    backgroundColor: "#0B66C2",
  },
  "&:focus": {
    backgroundColor: "#0B66C2",
  },
};

export const githubButtonStyle = {
  backgroundColor: "#238636",
  margin: "1rem 1rem",
  "&:hover": {
    backgroundColor: "#238636",
  },
  "&:active": {
    backgroundColor: "#238636",
  },
  "&:focus": {
    backgroundColor: "#238636",
  },
};

export const githubButtonStyle2 = {
  backgroundColor: "#333",
  margin: "1rem 1rem",
  "&:hover": {
    backgroundColor: "#333",
  },
  "&:active": {
    backgroundColor: "#333",
  },
  "&:focus": {
    backgroundColor: "#333",
  },
};
